import styled from 'styled-components';

export const DescriptionWrapper = styled.div`
  line-height: 1.5rem;
  text-align: center;
  margin-bottom: 1.5rem;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  flex-flow: column;
`;

export const ModalButtonWrapper = styled.div`
  & > button,
  form button {
    height: 2.75rem;
    padding: 0 0.5625rem;
    text-transform: none;
    font-weight: normal;
  }
`;
